import {
  Calendar,
  CalendarCheck,
  Clock,
  RefreshCcw,
  FileText,
} from "lucide-react";
import type { ComponentType } from "react";

export const DASHBOARD_COLORS = {
  accent: "#6D28D9",
  accentTint: "#6D28D914",
  brandGrad: "linear-gradient(135deg, #6D28D9, #6D28D9CC)",
  textPrimary: "#1A1730",
  textSecondary: "#6B7280",
  textTertiary: "#9CA3AF",
  border: "#F0EEF6",
  cardBg: "#FFFFFF",
} as const;

export const CARD_CLASS =
  "bg-surface border border-border-secondary rounded-card shadow-soft";

export interface QuickStatConfig {
  key: string;
  label: string;
  sub: string;
  Icon: ComponentType<{ className?: string }>;
  iconBg: string;
  iconColor: string;
}

export const QUICK_STAT_CONFIGS: QuickStatConfig[] = [
  {
    key: "leaveBalance",
    label: "Leave Balance",
    sub: "days remaining",
    Icon: Calendar,
    iconBg: "#F3EEFF",
    iconColor: "#6D28D9",
  },
  {
    key: "presentDays",
    label: "Present Days",
    sub: "this month",
    Icon: CalendarCheck,
    iconBg: "#ECFDF5",
    iconColor: "#059669",
  },
  {
    key: "loggedHours",
    label: "Logged Hours",
    sub: "this week",
    Icon: Clock,
    iconBg: "#EFF6FF",
    iconColor: "#2563EB",
  },
  {
    key: "compOffs",
    label: "Comp Offs",
    sub: "available",
    Icon: Calendar,
    iconBg: "#FFF0F6",
    iconColor: "#DB2777",
  },
];

export interface QuickActionConfig {
  key: string;
  label: string;
  path: string;
  Icon: ComponentType<{ className?: string }>;
  iconBg: string;
  iconColor: string;
}

export const QUICK_ACTIONS: QuickActionConfig[] = [
  {
    key: "apply-leave",
    label: "Apply Leave",
    path: "/apply-leave",
    Icon: Calendar,
    iconBg: "#F3EEFF",
    iconColor: "#6D28D9",
  },
  {
    key: "regularize",
    label: "Regularize",
    path: "/attendance-regularization",
    Icon: RefreshCcw,
    iconBg: "#EFF6FF",
    iconColor: "#2563EB",
  },
  {
    key: "timesheet",
    label: "Fill Timesheet",
    path: "/my-timesheets",
    Icon: Clock,
    iconBg: "#ECFDF5",
    iconColor: "#059669",
  },
  {
    key: "documents",
    label: "My Documents",
    path: "/my-profile",
    Icon: FileText,
    iconBg: "#FFFBEB",
    iconColor: "#D97706",
  },
];

export const WEEKDAY_SHORT = ["Mon", "Tue", "Wed", "Thu", "Fri"] as const;
